export default __webpack_public_path__ + "static/media/no_image_1.a33b48dd.jpg";